import { take, call, put} from 'redux-saga/effects';
import {
    delJigyosha,
    failDelJigyosha,
    failGetJigyosha,
    failGetJigyoshaListWD, failRestoreJigyosha,
    failSetJigyosha,
    getJigyosha,
    getJigyoshaListWD, restoreJigyosha,
    setJigyosha, successDelJigyosha,
    successGetJigyosha,
    successGetJigyoshaListWD, successRestoreJigyosha,
    successSetJigyosha,
    getButsuryuBoten,
    failGetButsuryuBoten,
    successGetButsuryuBoten,
    getMaker,
    failGetMaker,
    successGetMaker


} from '../../actions';
import superFetch from '../../modules/superFetch';
import {getApiUrl} from "./../index";


export function* handleGetJigyoshaListWD() {
    while (true) {
        yield take(`${getJigyoshaListWD}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/get-jigyousha-list/',
            type: 'POST',
            data: {include_delete:true}
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failGetJigyoshaListWD({err:msg}));
            continue;
        }
        yield put(successGetJigyoshaListWD(Object.assign({}, payload, {})));
    }
}


export function* handleGetJigyosha() {
    while (true) {
        const action = yield take(`${getJigyosha}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/get-jigyousha/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failGetJigyosha({err:msg}));
            continue;
        }
        yield put(successGetJigyosha(Object.assign({}, payload, {})));
    }
}

export function* handleSetJigyosha() {
    while (true) {
        const action = yield take(`${setJigyosha}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/set-jigyousha/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failSetJigyosha({err:msg}));
            continue;
        }
        yield put(successSetJigyosha(Object.assign({}, payload, {})));
    }
}

export function* handleDelJigyosha() {
    while (true) {
        const action = yield take(`${delJigyosha}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/del-jigyousha/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failDelJigyosha({err:msg}));
            continue;
        }
        yield put(successDelJigyosha(Object.assign({}, payload, {})));
    }
}

export function* handleRestoreJigyosha() {
    while (true) {
        const action = yield take(`${restoreJigyosha}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/restore-jigyousha/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failRestoreJigyosha({err:msg}));
            continue;
        }
        yield put(successRestoreJigyosha(Object.assign({}, payload, {})));
    }
}

export function* handleGetButsuryuBoten() {
    while (true) {
        const action = yield take(`${getButsuryuBoten}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/get-butsuryuboten-info/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failGetButsuryuBoten({err:msg}));
            continue;
        }
        yield put(successGetButsuryuBoten(Object.assign({}, payload, {})));
    }
}

export function* handleGetMaker() {
    while (true) {
        const action = yield take(`${getMaker}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/get-maker-info/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failGetMaker({err:msg}));
            continue;
        }
        yield put(successGetMaker(Object.assign({}, payload, {})));
    }
}







// WEBPACK FOOTER //
// ./src/sagas/master/jigyousha.js